<template>
	<module-tab name="退货退款" enable-flex @mounted="$refs.search.search()" @activated="$refs.table.update()">
		<m-search ref="search" @search="searchHandle">
			<m-search-item label="退款单号">
				<c-input name="return_number"></c-input>
			</m-search-item>
			<m-search-item label="订单号">
				<c-input name="order_number"></c-input>
			</m-search-item>
			<m-search-item label="申请时间" colspan="2">
				<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
			</m-search-item>
			<m-search-item label="售后类型">
                <c-checkbox-group name="return_type" :options="returnTypeOptions"></c-checkbox-group>
			</m-search-item>
			<m-search-item label="退款状态" colspan="2">
				<c-checkbox-group name="return_state" :options="stateOptions"></c-checkbox-group>
			</m-search-item>
		</m-search>
        <m-operate>
            <c-button color="m" hollow @click="syncExport()">导出</c-button>
        </m-operate>
		<c-table ref="table" height="grow">
			<c-table-column
				width="400"
			>
				<template slot="head">
					<span style="margin-left: 15px;">退货商品信息</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="申请数量"
				width="80"
				align-center
			></c-table-column>

			<c-table-column
				label="申请金额"
				width="110"
				align-center
			></c-table-column>

			<c-table-column
				label="实退金额"
				width="110"
				align-center
			></c-table-column>
			
			<c-table-column
				label="退款状态"
				width="170"
				align-center
			></c-table-column>
			
			<c-table-column
				label="操作"
				width="170"
				align-center
			></c-table-column>
			
			<template #custom="{data}">
				<div :key="data.id" class="order">
					<div class="order-head flex-between-center">
						<div class="flex-center">
                            <div v-if="data.return_type ==2" class="tag" style="background: #B232FE">仅退款</div>
                            <div v-if="data.return_type ==1" class="tag" style="background: #0066F1">退货退款</div>
							<span class="number">退货单号：{{data.return_number}}</span>
							<p class="info">
                                关联订单号：<c-link @click="navigateTo(`/order_detail/${data.order_number}`)">{{data.order_number}}</c-link>
                            </p>
							<p class="info">
                                申请时间：{{data.create_date}}
                            </p>
							<p class="info" v-if="data.operation_mode == 2">
                                买家：{{data.nick_name||data.receiving_name}}
                            </p>
						</div>
					</div>
					<div class="flex">
						<div class="order-product">
							<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
								<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
								<div class="flex-grow">
                                    <p class="sku-name ellipsis">
                                        <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                        {{sku.product_name}}
                                    </p>
									<p class="sku-spec">{{sku.product_sku_spec}}</p>
								</div>
							</div>
						</div>
						<div class="order-sum flex-column flex-center">{{(data.product_count)}}</div>
						<div class="order-sum flex-column flex-center">￥{{(data.apply_return_money)}}</div>
						<div class="order-sum flex-column flex-center">￥{{data.return_total_money}}</div>
						<div class="order-state flex-column flex-center">{{stateData[data.return_state].name}}</div>
						<div class="order-handle flex-column flex-center">
							<c-button power="b_return_info_detail" @click="navigateTo(`/after_sale_detail/return/${data.return_number}`)">查看详情</c-button>
						</div>
					</div>
				</div>
			</template>
		</c-table>
	</module-tab>
</template>

<script>
	export default {
		props: {
			return_state: String
		},
		
		data() {
			return {
                workType:21,
                searchParams:{},
				stateOptions: [{
					name: '待审核',
					value: 1
				}, {
					name: '待用户退货',
					value: 2
				}, {
					name: '待财务打款',
					value: 3
				}, {
					name: '退款成功',
					value: 5
				}, {
					name: '已驳回',
					value: 6
				}, {
					name: '已撤销',
					value: 8
				}],
                returnTypeOptions: [{
					name: '退货退款',
					value: 1
				}, {
					name: '仅退款',
					value: 2
				}]
			}
		},
		
		computed: {
			stateData() {
				let arr = [];
				this.stateOptions.forEach(item => {
					arr[item.value] = item;
				});
				
				return arr;
			}
		},
			
		mounted() {
			this.$refs.search.set({
				return_state: this.return_state
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/returns/detail_list',
					data
				});
                this.searchParams = data;
			},
            /**同步导出数据**/
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>

<style>
.tag {
    border-radius: 2px;
    padding: 0 5px;
    margin-left: 6px;
    line-height: 18px;
    color: #fff;
}
</style>